const initBingEvents = () => {
    if (typeof uet_report_conversion === 'undefined') {
        return;
    }

    document.addEventListener('click', function (e) {
        let tagName = e.target.tagName.toLowerCase(),
            href = '';

        if (tagName === 'a') {
            href = e.target.getAttribute('href');
        } else if (e.target.closest('a')) {
            href = e.target.closest('a').getAttribute('href');
        }

        if (href.indexOf('/go/vendor') !== -1) {
            if (window.location.hostname.indexOf(".int") === -1) {
                uet_report_conversion();
            } else if (document.body.classList.contains('logged-in')) {
                console.log('Bing outbound_click Event tracked');
            }
        }
    });
};

if (document.readyState === 'complete') {
    initBingEvents();
} else {
    window.addEventListener('load', initBingEvents, { once: true });
}
